export default function LoadingIcon ({
  className = 'relative w-8 h-8 bg-transparent inline-block'
}) {
  return(

    <svg
    className={className}
    viewBox='0 0 100 100'
    preserveAspectRatio='xMidYMid'
  >
    <g transform='translate(25 50)'>
        <circle cx='0' cy='0' r='7' fill='rgba(15, 208, 139, 1)'>
          <animateTransform
            attributeName='transform'
            type='scale'
            begin='-0.3333333333333333s'
            calcMode='spline'
            keySplines='0.3 0 0.7 1;0.3 0 0.7 1'
            values='0;1;0'
            keyTimes='0;0.5;1'
            dur='1s'
            repeatCount='indefinite'
            />
        </circle>
      </g>
      <g transform='translate(50 50)'>
        <circle cx='0' cy='0' r='7' fill='rgba(15, 208, 139, 0.6)'>
          <animateTransform
            attributeName='transform'
            type='scale'
            begin='-0.16666666666666666s'
            calcMode='spline'
            keySplines='0.3 0 0.7 1;0.3 0 0.7 1'
            values='0;1;0'
            keyTimes='0;0.5;1'
            dur='1s'
            repeatCount='indefinite'
            />
        </circle>
      </g>
      <g transform='translate(75 50)'>
        <circle cx='0' cy='0' r='7' fill='rgba(15, 208, 139, 0.3)'>
          <animateTransform
            attributeName='transform'
            type='scale'
            begin='0s'
            calcMode='spline'
            keySplines='0.3 0 0.7 1;0.3 0 0.7 1'
            values='0;1;0'
            keyTimes='0;0.5;1'
            dur='1s'
            repeatCount='indefinite'
            />
        </circle>
      </g>
    </svg>
)
}
